import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { fonts, space } from 'folio-common-components';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageCard } from '../../components/Section';
import { TextButton } from '../../components/buttons';
import { PageHeading } from '../../components/page-heading';
import { SmallArrowDownIcon } from '../../icons';
import { pageMap } from '../../paths';
import { setBankSelection } from '../../services';
import { useActions, useSelector } from '../../state';

const CitizenshipPage: React.FC = () => {
  const { id } = useSelector(e => ({
    id: e.founding.id,
  }));
  const { foundingActions } = useActions();
  const navigate = useNavigate();

  const applyBankSelection = async () => {
    const selection = 'OTHER_NAGGED';
    await setBankSelection({ id, selection });
    foundingActions.updateFounding({
      bankSelection: selection,
    });

    navigate({
      pathname: pageMap.status,
      search: window.location.search,
    });
  };

  return (
    <PageCard>
      <PageHeading>Statsborger&shy;skap og bedrifts&shy;konto</PageHeading>

      <>
        <SmallArrowDownIcon
          css={css`
            color: var(--system-blue-700);
          `}
        />{' '}
        <a lang="en" href="#english">
          English version
        </a>
      </>

      <p>
        Vi er lei for det, men alle på eiersiden av selskapet kan kun ha norsk
        statsborger&shy;skap, for å få en bedrifts&shy;konto hos oss. Du kan
        fortsette stiftelses&shy;prosessen her, du må bare velge en annen bank.
      </p>

      <p>
        <TextButton onClick={() => applyBankSelection()}>
          Fortsett å stifte med en annen bank
        </TextButton>
      </p>

      <Section>
        <Heading>Men jeg har permanent oppholdstillatelse?</Heading>
        <p>
          Det hjelper ikke på problemet vi står overfor dessverre. Utenlandske
          statsborgere krever prosesser som vi ikke har på plass enda.
        </p>
      </Section>

      <Section>
        <Heading>Men jeg skatter jo til Norge og har gjort det lenge?</Heading>
        <p>Dessverre hjelper ikke dette heller.</p>
      </Section>

      <Section>
        <Heading>Når skal dere fikse dette?</Heading>
        <p>
          Det er er et spørsmål om ressurser, og vi er et lite selskap, derfor
          tør vi ikke anslå noe tidspunkt. Men vi ønsker oss selvsagt så mange
          kunder som mulig, og vil åpne for alle så fort det lar seg gjøre.
        </p>
      </Section>

      <p>
        <TextButton onClick={() => applyBankSelection()}>
          Fortsett å stifte med en annen bank
        </TextButton>
      </p>

      <div
        id="english"
        lang="en-US"
        css={css`
          margin-top: 48px;
        `}
      >
        <PageHeading>Citizenship and business account</PageHeading>

        <p>
          To get a Folio business account, everyone with a stake in the company
          need to have a Norwegian citizenship. Dual citizenship is not allowed.
          You may still use this process to found your company, but you will
          need to use another bank in the next step.
        </p>

        <p>
          <TextButton onClick={() => applyBankSelection()}>
            Continue founding with another bank
          </TextButton>
        </p>

        <Section>
          <Heading>But I have permanent residency?</Heading>
          <p>
            We are sorry, but that does not change the situation. Aquiring
            customers with foreign citizenship demand procedures that we do not
            have in place yet.
          </p>
        </Section>

        <Section>
          <Heading>
            But I pay my taxes in Norway and have done so for a long time?
          </Heading>
          <p>Sorry, but that does not change the demands on us.</p>
        </Section>

        <Section>
          <Heading>When will you fix this problem?</Heading>
          <p>
            This will require significant resources, and we are a small
            business, so it’s hard to say the exact time. But naturally we wish
            to have as many customers as we can, and will open to everyone as
            soon as possible.
          </p>
        </Section>

        <p>
          <TextButton onClick={() => applyBankSelection()}>
            Continue founding with another bank
          </TextButton>
        </p>
      </div>
    </PageCard>
  );
};

const Section = styled.div`
  ${space([32], 'margin-top')}
`;

const Heading = styled.h3`
  ${fonts.font300demi};
  margin-bottom: 0;
`;

// React.lazy only supports default exports:
// https://reactjs.org/docs/code-splitting.html#named-exports
// eslint-disable-next-line import/no-default-export
export default CitizenshipPage;
